import { render, staticRenderFns } from "./ViewSetting.vue?vue&type=template&id=965bed00&scoped=true&"
import script from "./ViewSetting.vue?vue&type=script&lang=js&"
export * from "./ViewSetting.vue?vue&type=script&lang=js&"
import style0 from "./ViewSetting.vue?vue&type=style&index=0&id=965bed00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965bed00",
  null
  
)

export default component.exports